import { storeUtmParams } from '@ifixit/analytics';

// This immediately invoked function expression (IIFE) invokes the storeUtmParams function.
{
   if (App.which === 'ifixit') {
      storeUtmParams();
   }
}
